import { createReducer } from '@reduxjs/toolkit';
import {
clearedNotification, clearNotification, enqueueErrorNotification,
  enqueueInfoNotification,   enqueueMessage, enqueueWarningNotification,
removeNotification, } from 'core/redux/actions/notification/notificationActions';
import type { Notification } from 'core/redux/reducers/notification/notificationReducer.types';

import type { NotificationState } from './notificationReducer.types';

const initialState: NotificationState = {
  stack: [],
  clear: false,
};

const enqueueNotificationFormatter = (
  state: NotificationState,
  notification: Notification,
) => ({
  ...state,
  stack: [
    ...state.stack,
    { ...notification },
  ],
});

const notificationReducer = createReducer(initialState, (builder) => builder

  .addCase(enqueueInfoNotification, (state, action) => (
    enqueueNotificationFormatter(state, action.payload.notification)
  ))

  .addCase(enqueueWarningNotification, (state, action) => (
    enqueueNotificationFormatter(state, action.payload.notification)
  ))

  .addCase(enqueueErrorNotification, (state, action) => (
    enqueueNotificationFormatter(state, action.payload.notification)
  ))

  .addCase(enqueueMessage, (state, action) => (
    enqueueNotificationFormatter(state, action.payload.notification)
  ))

  .addCase(clearNotification, (state) => (
    { ...state, clear: true }
  ))

  .addCase(clearedNotification, (state) => (
    { ...state, clear: false }
  ))

  .addCase(removeNotification, (state, action) => ({
    ...state,
    stack: state.stack.filter(
      (notification) => notification.key !== action.payload.key,
    ),
  })));

export default notificationReducer;
